import React from 'react';
import WorkspaceIcon from '../../../assets/images/svg-icons-material-io/workspaces_FILL0_wght400_GRAD0_opsz48.svg';
import MailboxIcon from '../../../assets/images/svg-icons-material-io/local_post_office_FILL0_wght400_GRAD0_opsz48.svg';
import MailFwdIcon from '../../../assets/images/svg-icons-material-io/forward_to_inbox_FILL0_wght400_GRAD0_opsz48.svg';
import { Link } from 'react-router-dom';

const SubMenu = () => (
    <div className="SubMenu">
        {/*Sub menus for User Reports*/}

        <section id="btnUserReport" className="dashboard-subcontainer collapse" title="Sub menus for User Reports">
            {/*User Activity Reports Box*/}
            <Link to={'/user-activity'} className="btn btn-primary dash-box box-user-activity animate slide delay-1" title="User Activity Reports" alt="Navigate to user activity reports">
                <div className="box-icon">
                    <img src={WorkspaceIcon} className="filter-white" alt="User Activity Icon" />
                </div>
                <div className="box-bottom">
                    <div className="title">User Activity</div>
                    <div className="sub-title">Reports</div>
                </div>
            </Link>
            {/*Delete Activity Reports Box*/}
            <Link to={'/delete-user-activity'} className="btn btn-primary dash-box box-delect-activity animate slide delay-2" title="Delete Activity Reports" alt="Navigate to delete activity reports">
                <div className="box-icon">
                    <i className="bi bi-trash" alt="Trash Icon"></i>
                </div>
                <div className="box-bottom">
                    <div className="title">Delete Activity</div>
                    <div className="sub-title">Reports</div>
                </div>
            </Link>
            {/*Mailbox Sizes Reports Box*/}
            <Link to={'/mailbox-size'} className="btn btn-primary dash-box box-mailbox animate slide delay-3" title="Mailbox Size Report" alt="Navigate to mailbox sizes reports" >
                <div className="box-icon">
                    <img src={MailboxIcon} className="filter-white" alt="Mailbox sizes Icon" />
                </div>
                <div className="box-bottom">
                    <div className="title">Mailbox Sizes</div>
                    <div className="sub-title">Reports</div>
                </div>
            </Link >
            {/*User Status Reports Box*/}
            <Link to={'/user-status'} className="btn btn-primary dash-box box-userstatus animate slide delay-4" title="User Status Reports" alt="Navigate to user status reports" >
                <div className="box-icon">
                    <i className="bi bi-clipboard2-data" alt="User Status Icon"></i>
                </div>
                <div className="box-bottom">
                    <div className="title">User Status</div>
                    <div className="sub-title">Reports</div>
                </div>
            </Link >
            {/*Message Forwarding Reports Box*/}
            <Link to={'/message-forwarding'} className="btn btn-primary dash-box box-msgfwd animate slide delay-5" title="Message Forwarding Reports" alt="Navigate to message forwarding reports">
                <div className="box-icon">
                    <img src={MailFwdIcon} className="filter-white" alt="Message Forward Icon" />
                </div>
                <div className="box-bottom">
                    <div className="title">Message Forwarding</div>
                    <div className="sub-title">Reports</div>
                </div>
            </Link>
        </section >
    </div>
);

SubMenu.defaultProps = {};

export default SubMenu;
